import React from 'react';

function SingleOptionQuestion({ question, value = { answer: '', otherAnswer: '' }, onChange, disabled = false }) {
  // Handle the main radio button selection
  const handleOptionChange = (selectedOption) => {
    onChange({ 
      answer: selectedOption, 
      otherAnswer: value.otherAnswer || '' 
    });
  };

  // Handle the "Other" text input change
  const handleOtherChange = (e) => {
    onChange({ 
      answer: value.answer || '', 
      otherAnswer: e.target.value 
    });
  };

  return (
    <div className="space-y-4">
      {question.options.map((option, index) => (
        <label 
          key={index} 
          className={`flex items-center p-3 rounded-lg transition-all duration-200 ${
            value.answer === option 
              ? 'bg-blue-50 border border-blue-200 shadow-sm' 
              : 'hover:bg-gray-50 border border-transparent'
          } ${disabled ? 'opacity-70 cursor-not-allowed' : 'cursor-pointer'}`}
        >
          <input
            type="radio"
            name={`question-${question.id}`}
            value={option}
            checked={value.answer === option}
            onChange={(e) => handleOptionChange(e.target.value)}
            className="form-radio h-5 w-5 text-blue-600 focus:ring-blue-500"
            disabled={disabled}
          />
          <span className={`ml-3 text-gray-800 ${value.answer === option ? 'font-medium' : ''}`}>
            {option}
          </span>
        </label>
      ))}
      
      {/* Other text input field */}
      <div className="mt-6 p-4 border border-gray-200 rounded-lg bg-gray-50">
        <label className="flex flex-col w-full">
          <span className="text-gray-800 mb-3 font-medium text-lg">Other input:</span>
          <input
            type="text"
            value={value.otherAnswer || ''}
            onChange={handleOtherChange}
            className="form-input rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 py-3 px-4 text-base w-full"
            placeholder="Enter alternative or additional input..."
            disabled={disabled}
          />
        </label>
      </div>
    </div>
  );
}

export default SingleOptionQuestion;
